import {Button as AriaButton} from 'react-aria-components'
import styled, {css} from 'styled-components'
import {ButtonSize, type ButtonStyleProps, ButtonVariant} from './button.types'
import {Colors} from '../../../theme/colours'
import {KeyboardFocusOutline} from '../base.styled'

// TODO: Change once design system has specific color
export const DISABLED_COLOR = '#E2E5E9'

export const ButtonStyles = css<ButtonStyleProps>`
    background-color: ${(props) => {
        if (props.variant === ButtonVariant.Solid) {
            // In design system it is this color
            return Colors.blue2
        } else if (
            props.variant === ButtonVariant.Outlined ||
            props.variant === ButtonVariant.Icon
        ) {
            return 'inherit'
        }
        // This should not happen cause we already set default in the component
        else {
            throw new Error('Undefined button variant')
        }
    }};

    color: ${(props) => {
        if (props.variant === ButtonVariant.Solid) {
            return Colors.white
        } else if (
            props.variant === ButtonVariant.Outlined ||
            props.variant === ButtonVariant.Icon
        ) {
            return Colors.blue2
        } else {
            throw new Error('Undefined button variant')
        }
    }};

    border: ${(props) => {
        if (props.variant === ButtonVariant.Solid || props.variant === ButtonVariant.Outlined) {
            return `2px solid ${Colors.blue2}`
        } else if (props.variant === ButtonVariant.Icon) {
            return 'none'
        }
        throw new Error('Undefined button variant')
    }};

    border-radius: 4px;

    padding-inline: ${(props) => {
        if (props.size === ButtonSize.LG) {
            return '14px'
        } else if (props.size === ButtonSize.MD) {
            return '12px'
        } else if (props.size === ButtonSize.SM) {
            return '10px'
        } else if (props.size === ButtonSize.XS) {
            return '8px'
        }
        throw new Error('Undefined button size')
    }};
    padding-block: ${(props) => {
        if (props.size === ButtonSize.LG) {
            return '11.5px'
        } else if (props.size === ButtonSize.MD) {
            return '10.5px'
        } else if (props.size === ButtonSize.SM) {
            return '9.5px'
        } else if (props.size === ButtonSize.XS) {
            return '8.5px'
        }
        throw new Error('Undefined button size')
    }};
    font-size: 14px;

    // Stole from tailwind
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;

    &[data-hovered] {
        background-color: ${(props) => {
            if (props.variant === ButtonVariant.Solid) {
                return Colors.blue3
            } else if (
                props.variant === ButtonVariant.Outlined ||
                props.variant === ButtonVariant.Icon
            ) {
                return Colors.blue1
            } else {
                throw new Error('Undefined button variant')
            }
        }};
    }

    &[data-disabled] {
        border: 2px solid transparent;
        background-color: ${DISABLED_COLOR};
        color: ${Colors.white};
    }

    &[data-disabled][data-hovered] {
        background-color: ${DISABLED_COLOR};
    }

    ${KeyboardFocusOutline}
`

export const StyledButton = styled(AriaButton)<ButtonStyleProps>`
    ${ButtonStyles}
`
